export default __webpack_public_path__ + "static/media/Flag_of_Nauru.58b31796.svg";